'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styles = {"sticky-container":"sticky-section_sticky-container__El0Ji","anchor-bottom":"sticky-section_anchor-bottom__DUDvW","anchor-top":"sticky-section_anchor-top__gRTyc","expansion-section":"sticky-section_expansion-section__cEnSS","expansion-show":"sticky-section_expansion-show__VZVAR","expansion-hide":"sticky-section_expansion-hide__wUs-E"};

exports.default = styles;
//# sourceMappingURL=sticky-section.scss.js.map
